<template>
    <f7-page
        name="Topic"
        no-swipeback
        class="onboardingBg withHalfBgTaupe"
    >

        <f7-navbar
            :title-large="' '"
            inner
            large
            no-hairline
            large-transparent
            inner-class="onboardingBg"
        >

            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="goBack()"
                />
            </f7-nav-left>
            <f7-nav-title>{{ topic.name }}</f7-nav-title>
            <f7-nav-right />
        </f7-navbar>

        <f7-block>
            <h1 style="margin-top: -30px">{{ topic.name }}</h1>
            <p v-if="topic.data.audioIntroAttachmentId">Coral's founder, Isharna, describes this goal.</p>
            <p
                v-else
                v-html=" topic.description"
            > <br><br></p>
        </f7-block>
        <template v-if="topic.data.audioIntroAttachmentId">
            <div style="z-index: 20; position: relative; margin-top: -20px; padding-top: 20px; max-width: 100vw; overflow: hidden;">
                <audio-player
                    :sources="[attachment.data.audioUrl]"
                    :volume="1"
                    :loop="false"
                    :attach="attachment"
                    :color="topic.color || false"
                    :unit="false"
                    :html5="true"
                    :url="`/topics/${topic.id}`"
                    :key="`attach-${attachment.id}`"
                />
            </div>
        </template>
        <div class="topicBottom">

            <f7-button
                :color="myTopics.indexOf(topic.id) > -1 ? 'white' : 'red'"
                fill
                round
                style="z-index: 9; max-width: 230px; margin: 0px auto 16px"
                @click="addToMyGoals"
            >{{ myTopics.indexOf(topic.id) === -1 ? 'Add to my goals' : 'Remove from my goals' }}</f7-button>

            <f7-block
                v-if="topic.description"
                class="topicDescription"
                v-html="topic.description"
            />
            <div
                class="exploreContentSection"
                style="min-height: 60vh"
            >
                <f7-block v-if="fullDataIndex[topic.id].courses.length === 0"><br><br>No courses are relevant to you</f7-block>
                <f7-block class="non-swipe-tiles">
                    <template v-for="(course, i) in fullDataIndex[topic.id].courses">
                        <div
                            v-if="checkTraits(course)"
                            :key="i"
                            class="non-swipe-tile"
                        >
                            <course-card
                                :course="course"
                                :topic="topic"
                                :index="i"
                                :link="`/courses/${course.id}`"
                                :key="`t-${i}`"
                                :locked="false"
                                :is-learn="['learn','goal'].indexOf(course.type) > -1"
                                :disabled="course.comingSoon"
                                :style="course.comingSoon ? 'opacity: 1' : ''"
                                :small="true"
                            />
                        </div>
                    </template>
                </f7-block>
                <br style="clear: both">
                <f7-link
                    v-if="hiddenCourses"
                    class="moreLink"
                    @click="toggleHidden"
                >{{ showHidden ? 'Hide' : 'Show' }} hidden courses &mdash;</f7-link>
                <br
                    v-if="showHidden"
                    style="clear: both"
                >
                <div v-if="hiddenCourses && showHidden">
                    <f7-block style="color: #686868; margin-top: 0px;margin-bottom: 0px;">These courses have been hidden because they are not relevant to your gender, sexual preference, relationship status or other traits. You can edit your traits in Settings.</f7-block>
                    <div
                        class="non-swipe-tiles;"
                        style="margin: 16px"
                    >
                        <template v-for="(course, i) in fullDataIndex[topic.id].courses">
                            <div
                                v-if="!checkTraits(course)"
                                :key="i"
                                class="non-swipe-tile"
                            >
                                <course-card
                                    :course="course"
                                    :topic="topic"
                                    :index="i"
                                    :link="`/courses/${course.id}`"
                                    :key="`t-${i}`"
                                    :locked="false"
                                    :is-learn="['learn','goal'].indexOf(course.type) > -1"
                                    :disabled="course.comingSoon"
                                    :style="course.comingSoon ? 'opacity: 1' : ''"
                                    :small="true"
                                />
                            </div>
                        </template>
                    </div>
                </div>
                <br style="clear: both">
            </div>
        </div>

    </f7-page>
</template>

<script>
import CourseCard from '../../components/courseCard.vue';
import AudioPlayer from '../../components/attachments/audioPlayer.vue';

import utils from '../../js/utils';

export default {
    components: {
        CourseCard,
        AudioPlayer
    },
    store: ['api', 'user', 'topics', 'topicsIndex', 'fullDataIndex', 'myTopics', 'myTraits'],
    data () {
        return {
            currentId: 0,
            topic: {
                id: 0,
                topicId: 0,
            },
            showHidden: false,
            hiddenCourses: 0,
            attachment: {
                id: {},
                data: {
                    audioUrl: '',
                    transcript: '...................................................'
                },
            },
            showTranscript: false,
            firstShowTranscript: false,
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    created: function () {
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        if (this.topicsIndex[this.currentId]) {
            this.topic = this.topicsIndex[this.currentId];
            this.hiddenCourses = 0;
            for (let i = 0; i < this.fullDataIndex[this.topic.id].courses.length; i++) {
                const element = this.fullDataIndex[this.topic.id].courses[i];
                if (!this.checkTraits(element)) this.hiddenCourses++;
            }
            this.$events.fire(
                'trackEvent',
                'topic_view',
                'progress',
                this.topic.id,
                this.topic.name,
                this.topic
            );
        }
        if (this.topic.type === 'goal' && this.topic.data.audioIntroAttachmentId) {
            this.getAttachment();
        }
    },
    mounted: function () {

    },
    methods: {
        toggleHidden: function () {
            this.showHidden = !this.showHidden;
            this.$events.fire('trackEvent', `show_hidden`, 'ui', this.topic.id, 'topic', this.topic);
        },
        getAttachment: function () {
            this.$http.get(`${this.api}/attachments/${this.topic.data.audioIntroAttachmentId || '122'}`).then(
                response => {
                    this.attachment = response.body || {};
                },
                () => { }
            );
        },
        addToMyGoals: function () {
            if (this.myTopics.indexOf(this.topic.id) > -1) {
                if (this.myTopics.length > 0) this.myTopics.splice(this.myTopics.indexOf(this.topic.id), 1);
                this.$events.fire('trackEvent', `topic_removed`, 'content', this.topic.id, this.topic.name, this.topic);
            } else {
                this.myTopics.push(this.topic.id);
                this.$events.fire('trackEvent', `topic_added`, 'content', this.topic.id, this.topic.name, this.topic);
            }
            this.$http.post(`${this.api}/users/${this.user.id}/topics`, {
                topicIds: this.myTopics
            }).then(
                () => {
                    console.log('topics saved');
                },
                response => {
                    console.error(response.body.message || 'Unknown error');
                }
            );
        },
        checkTraits: function (unit) {
            return utils.checkTraits(this.myTraits, unit);
        },
        goBack: function () {
            utils.backIfFirst(this);
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
.moreLink {
    color: @coral;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    float: right;
    clear: both;
}
.bottom {
    position: fixed;
    bottom: 60px;
    z-index: 9;
}
.coralButton {
    font-size: 18px;
    color: white;
    background: #8a9dd1;
    border-radius: 22px;
    padding: 15px 30px;
}

.topicTop {
    margin-bottom: 0px;
    padding-top: 130px;
    h1 {
        margin-top: -70px;
        padding-bottom: 70px;
        color: white;
    }
    // background-image: url('../../img/0.4/belly.png');
    background-image: url('../../img/1.4.0/goalwave.svg');
    background-position: bottom right;
    background-size: 100% auto;
    background-position: bottom left;
    background-repeat: no-repeat;
}
.topicBottom {
    background: white; //#d9ccc4;
    min-height: 60vh;
    margin-top: -1px;
    padding-top: 20px;
    max-width: 100vw;
    overflow: hidden;
}
.theme-dark {
    .topicBottom {
        background: #000;
    }
    .topicDescription {
        color: white;
    }
}
.non-swipe-tiles {
    text-align: left;
}
.non-swipe-tile {
    width: 110px;
    padding: 6px;
    margin: 0;
    float: left;
}

.exploreContentSection {
    position: relative;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    background-color: #dacdc5;
    background-image: url('../../img/0.4/bgwave.png');
    // background-size: 307px 11px;
    background-size: 460.5px 16.5px;
    background-position: top left;
    background-repeat: repeat-x;
    &.hasReverse:before {
        position: absolute;
        bottom: 0px;
        content: '';
        width: 100vw;
        height: 16.5px;
        background-position: bottom left;
        background-size: 460.5px 16.5px;
        background-image: url('../../img/0.4/bgwave.png');
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}
.theme-dark {
    .exploreContentSection {
        background-color: #1c1c1d;

        background-image: url('../../img/0.4/bgwavedark.png');
    }
}
</style>
